import React, { createContext, useState, useEffect } from 'react';
import mixpanel from 'mixpanel-browser';
import { withRouter } from 'react-router-dom';
import qs from 'qs';

export const DrawerContext = createContext();

const DrawerContextProvider = (props) => {
    const [isVisible, setIsVisible] = useState(false);

    const query = qs.parse(props.location.search.slice(1));

    const closeDrawer = () => {
        setIsVisible(false);
        mixpanel.track('Closed Add new drawer');
    };

    const openDrawer = () => {
        setIsVisible(true);
        mixpanel.track('Opened Add new drawer');
    };

    useEffect(() => {
        // open drawer if url has event=add
        if (query.event === 'add') setIsVisible(true);
    }, []);

    return (
        <DrawerContext.Provider
            value={{ isVisible, setIsVisible, closeDrawer, openDrawer }}
        >
            {props.children}
        </DrawerContext.Provider>
    );
};

export default withRouter(DrawerContextProvider);
